import "./PhoneNumberTypeLabel.html";

import type { IControllerConstructor, Injectable } from "angular";
import { PhoneNumberTypeComponentController } from "./PhoneNumberTypeComponentController";

export class PhoneNumberTypeLabelComponent implements ng.IComponentOptions {
    public templateUrl: string;

    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    constructor() {
        this.bindings = {
            ngModel: "=",
        };

        this.controller = PhoneNumberTypeComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/PhoneNumberTypeLabel/PhoneNumberTypeLabel.html";
    }
}
